'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ovee_js = require('ovee.js');
var gsap = require('gsap');
var lodash = require('lodash');
var ScrollTrigger = require('gsap/ScrollTrigger');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var gsap__default = /*#__PURE__*/_interopDefaultLegacy(gsap);

const logger$5 = new ovee_js.Logger("BaseAccordion - animations");
const showAnimation = (args) => {
  const { item, immediate, speed, ease } = args;
  const { _trigger: trigger, _content: content } = item;
  if (!trigger || !content) {
    return logger$5.error("Missing trigger or content element");
  }
  trigger.setAttribute("aria-expanded", "true");
  content.style.pointerEvents = "all";
  const height = item.dataset.activeHeight ?? "auto";
  if (immediate === true) {
    item.style.height = `${height}px`;
    content.style.opacity = "1";
    return Promise.resolve();
  } else {
    gsap__default["default"].to(content, {
      duration: speed / 2,
      ease: "none",
      opacity: 1,
      delay: speed / 1.5,
      clearProps: "all"
    });
    return gsap__default["default"].to(item, {
      duration: speed,
      ease,
      height,
      clearProps: "all"
    });
  }
};
const hideAnimation = (args) => {
  const { item, height, immediate, speed, ease } = args;
  const { _trigger: trigger, _content: content } = item;
  const blockHeight = height ?? item.dataset.reducedHeight;
  if (!trigger || !content) {
    return logger$5.error("Missing trigger or content element");
  }
  trigger.setAttribute("aria-expanded", "false");
  content.style.pointerEvents = "none";
  if (immediate == true) {
    item.style.height = `${blockHeight}px`;
    content.style.opacity = "0";
    return Promise.resolve();
  } else {
    gsap__default["default"].to(content, {
      duration: speed / 2,
      ease: "none",
      opacity: 0
    });
    return gsap__default["default"].to(item, {
      duration: speed,
      ease,
      height: blockHeight,
      delay: 0.1
    });
  }
};

const calcHeights = (items, resize) => {
  if (!items.length) {
    return;
  }
  items.forEach((item) => {
    const { _trigger: trigger, _content: content } = item;
    if (!trigger || !content) {
      return;
    }
    const triggerHeight = trigger.offsetHeight;
    const contentHeight = content.offsetHeight;
    const itemData = item.dataset;
    itemData.reducedHeight = `${triggerHeight}`;
    itemData.activeHeight = `${triggerHeight + contentHeight}`;
    if (resize) {
      if (trigger.getAttribute("aria-expanded") === "true") {
        item.style.height = `${itemData.activeHeight}px`;
      } else {
        item.style.height = `${itemData.reducedHeight}px`;
      }
    }
  });
};

var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
const logger$4 = new ovee_js.Logger("BaseAccordion");
const BASE_ACCORDION_DEFAULT_OPTIONS = {
  firstActive: false,
  autoCollapse: false,
  immediate: false,
  speed: 0.4,
  ease: "power2.inOut"
};
exports.BaseAccordion = class extends ovee_js.Component {
  init() {
    this.options = {
      ...BASE_ACCORDION_DEFAULT_OPTIONS,
      ...this.$options
    };
    if (!this.items.length) {
      return logger$4.warn("No accordion items were found. You should specify them with data-accordion-item attribute");
    }
    this.initAttributes();
    this.calcHeights();
    this.setInitHeights();
    this.bind();
  }
  initAttributes() {
    this.items.forEach((item) => {
      const trigger = item.querySelector("[data-accordion-trigger]");
      const content = item.querySelector("[data-accordion-content]");
      const timestamp = Date.now();
      const id = `accordion-${timestamp + Math.floor(Math.random() * (timestamp - 0)) + 0}`;
      if (!trigger) {
        return logger$4.error("Missing trigger element. You should specify it with data-accordion-trigger attribute");
      }
      if (!content) {
        return logger$4.error("Missing content element. You should specify it with data-accordion-content attribute");
      }
      item._trigger = trigger;
      item._content = content;
      this.setAttributes(content, {
        id
      });
      this.setAttributes(trigger, {
        tabindex: "0",
        "aria-controls": id,
        "aria-expanded": "false"
      });
    });
  }
  setAttributes(el2, attrs) {
    for (const key in attrs) {
      el2.setAttribute(key, attrs[key]);
    }
  }
  calcHeights() {
    calcHeights(this.items, true);
  }
  setInitHeights() {
    const { options } = this;
    this.items.forEach((item, i) => {
      const animationConfig = {
        item,
        immediate: options.immediate,
        speed: options.speed,
        ease: options.ease
      };
      if (options.firstActive && i === 0) {
        this.show(animationConfig);
      } else {
        this.hide(animationConfig);
      }
    });
  }
  show(args) {
    showAnimation(args);
    this.$emit("base-accordion:show", args.item);
  }
  hide(args) {
    hideAnimation(args);
    this.$emit("base-accordion:hide", args.item);
  }
  handleTriggerEvent(e) {
    const trigger = e.target;
    const item = trigger.closest("[data-accordion-item]");
    const isExpanded = trigger.getAttribute("aria-expanded") === "true";
    const { options } = this;
    if (!item) {
      return logger$4.error("Failed to handle triggered event. Missing item element");
    }
    const animationConfig = {
      item,
      immediate: options.immediate,
      speed: options.speed,
      ease: options.ease
    };
    if (options.autoCollapse) {
      this.items.forEach((item2) => {
        const { _trigger: trigger2, _content: content } = item2;
        if (!trigger2 || !content) {
          return logger$4.error("Missing trigger or content element");
        }
        if (trigger2.getAttribute("aria-expanded") === "true") {
          this.hide(animationConfig);
        }
      });
    }
    if (!isExpanded) {
      this.show(animationConfig);
    } else {
      this.hide(animationConfig);
    }
  }
  clickHandler(e) {
    this.handleTriggerEvent(e);
  }
  keyDownHandler(e) {
    if (e.code === "Space" || e.code === "Enter") {
      this.handleTriggerEvent(e);
    }
  }
  bind() {
    if (!this.items)
      return;
    this.items.forEach(({ _trigger: trigger }) => {
      if (!trigger) {
        return logger$4.error("Failed to bind event listener. Missing trigger element");
      }
      this.$on("click", trigger, this.clickHandler);
      this.$on("keydown", trigger, this.keyDownHandler);
    });
  }
  destroy() {
    this.items.forEach(({ _trigger: trigger }) => {
      if (!trigger) {
        return;
      }
      this.$off("click", trigger, this.clickHandler);
      this.$off("keydown", trigger, this.keyDownHandler);
    });
  }
};
__decorateClass$8([
  ovee_js.el("[data-accordion-item]", { list: true })
], exports.BaseAccordion.prototype, "items", 2);
exports.BaseAccordion = __decorateClass$8([
  ovee_js.register("base-accordion")
], exports.BaseAccordion);

var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
const BASE_COOKIES_DEFAULT_OPTIONS = {
  storageKey: "cookies_accepted"
};
const logger$3 = new ovee_js.Logger("BaseCookies");
exports.BaseCookies = class extends ovee_js.Component {
  get cookiesAccepted() {
    return localStorage.getItem(this.storageKey) === "true";
  }
  init() {
    this.options = {
      ...BASE_COOKIES_DEFAULT_OPTIONS,
      ...this.$options
    };
    const key = this._storageKey || this.options.storageKey;
    if (!key) {
      logger$3.error(`No 'storageKey' option is provided via config nor via data param. This option is required`);
      return;
    }
    this.storageKey = key;
    this.statusCheck();
  }
  statusCheck() {
    if (!this.cookiesAccepted) {
      this.showPopup();
    } else {
      this.hidePopup();
    }
  }
  onClick() {
    this.hidePopup();
  }
  showPopup() {
    this.$element.classList.add("is-visible");
    this.$element.setAttribute("aria-hidden", "false");
  }
  hidePopup() {
    localStorage.setItem(this.storageKey, "true");
    this.$element.classList.remove("is-visible");
    this.$element.setAttribute("aria-hidden", "true");
  }
};
__decorateClass$7([
  ovee_js.dataParam("storageKey")
], exports.BaseCookies.prototype, "_storageKey", 2);
__decorateClass$7([
  ovee_js.bind("storage", window)
], exports.BaseCookies.prototype, "statusCheck", 1);
__decorateClass$7([
  ovee_js.bind("click", ".cookies__button")
], exports.BaseCookies.prototype, "onClick", 1);
exports.BaseCookies = __decorateClass$7([
  ovee_js.register("base-cookies")
], exports.BaseCookies);

var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
const logger$2 = new ovee_js.Logger("BaseDialog");
const BASE_DIALOG_DEFAULT_OPTIONS = {
  dialogRoot: ".dialog-root"
};
class BaseDialog extends ovee_js.TemplateComponent {
  constructor() {
    super(...arguments);
    this.rootClass = "";
    this.dialogRoot = document.querySelector(this.options.dialogRoot);
    this.isOpen = false;
  }
  get renderTarget() {
    return this.dialogTarget;
  }
  get options() {
    return {
      ...BASE_DIALOG_DEFAULT_OPTIONS,
      ...this.$options
    };
  }
  init() {
    const target = document.createElement("div");
    target._dialogInstance = this;
    this.dialogTarget = target;
    if (!this.dialogRoot) {
      logger$2.warn(`Dialog root wasn't found. Element with selector '${this.options.dialogRoot}' does not exist.`);
      return;
    }
    this.dialogRoot.append(target);
  }
  open() {
    this.$emit("dialog:before-open", null);
    this.isOpen = true;
    this.$emit("dialog:open", null);
  }
  close() {
    this.$emit("dialog:before-close", null);
    this.isOpen = false;
    this.$emit("dialog:close", null);
  }
  dialogWrapper(content) {
    return this.html`
			<div class="base-dialog ${this.isOpen ? "base-dialog--is-open" : ""} ${this.rootClass}">
				<div class="base-dialog__container">
					<div class="base-dialog__content">
						${content}
					</div>
				</div>

				<button type="button" class="base-dialog__close" @click=${this.close.bind(this)}>
					<span class="base-dialog__close-icon"></span>
				</button>
			</div>
		`;
  }
}
__decorateClass$6([
  ovee_js.reactive()
], BaseDialog.prototype, "isOpen", 2);

var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
const calcOffsetMap = {
  window: (self) => {
    return window.innerHeight * self.multiplier;
  },
  header: (self) => {
    return self.headerHeight * self.multiplier;
  },
  none: (self) => {
    return self.collapsingHeader === "sticky" ? self.headerHeight : 0;
  },
  default: (self) => {
    return self.numberOffset;
  },
  triggerPoint: (self) => {
    self.triggerEl = self.html.querySelector(self.triggerOffset);
    if (self.triggerEl) {
      return self.triggerEl.getBoundingClientRect().top;
    }
    return self.numberOffset;
  }
};
const COLLAPSING_HEADER_DEFAULT_OPTIONS = {
  throttle: 100
};
exports.CollapsingHeader = class extends ovee_js.Component {
  constructor() {
    super(...arguments);
    this.triggerOffset = "default";
    this._throttleValue = `${this.options.throttle}`;
    this.currentPosition = 0;
    this.lastPosition = 0;
    this.numberOffset = 0;
    this.isScrollingDown = true;
    this.pastTrigger = false;
  }
  get options() {
    return {
      ...COLLAPSING_HEADER_DEFAULT_OPTIONS,
      ...this.$options
    };
  }
  get throttleValue() {
    const parsed = JSON.parse(this._throttleValue);
    return lodash.isNumber(parsed) && !isNaN(parsed) ? parsed : this.options.throttle;
  }
  get isShown() {
    return this.html.classList.contains("header-visible");
  }
  get isModified() {
    return this.html.classList.contains("header-modified");
  }
  get isCollapsed() {
    return this.html.classList.contains("header-collapsed");
  }
  get multiplier() {
    return this.offsetMultiplier ? parseFloat(parseFloat(this.offsetMultiplier).toPrecision(2)) : 1;
  }
  init() {
    this.html = document.documentElement;
    this.headerHeight = this.$element.getBoundingClientRect().height;
    if (this.collapsingHeader === "sticky") {
      this.numberOffset = window.innerHeight;
      this.scrollListener = lodash.throttle(this.scrollSticky, this.throttleValue);
    } else if (this.collapsingHeader === "fixed") {
      this.scrollListener = lodash.throttle(this.scrollFixed, this.throttleValue);
    } else {
      this.scrollListener = lodash.throttle(this.scrollCollapsing, this.throttleValue);
    }
    this.calcOffsets();
    this.bind();
  }
  show() {
    if (!this.isShown) {
      this.html.classList.add("header-visible");
    }
  }
  hide() {
    if (this.isShown) {
      this.html.classList.remove("header-visible");
    }
  }
  collapse() {
    if (!this.isCollapsed) {
      this.html.classList.add("header-collapsed");
    }
  }
  uncollapse() {
    if (this.isCollapsed) {
      this.html.classList.remove("header-collapsed");
    }
  }
  addModifier() {
    if (!this.isModified) {
      this.html.classList.add("header-modified");
    }
  }
  removeModifier() {
    if (this.isModified) {
      this.html.classList.remove("header-modified");
    }
  }
  calcOffsets() {
    if (this.triggerOffset in calcOffsetMap) {
      this.numberOffset = calcOffsetMap[this.triggerOffset](this) ?? this.numberOffset;
    } else {
      this.numberOffset = calcOffsetMap.triggerPoint(this) ?? this.numberOffset;
    }
  }
  scrollStart() {
    this.currentPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.isScrollingDown = !(this.currentPosition < this.lastPosition);
    this.pastTrigger = this.currentPosition > this.numberOffset;
  }
  scrollEnd() {
    this.lastPosition = this.currentPosition;
  }
  scrollSticky() {
    this.scrollStart();
    if (!this.isScrollingDown && this.pastTrigger) {
      this.show();
    } else {
      this.hide();
    }
    if (this.pastTrigger) {
      this.addModifier();
    } else {
      this.removeModifier();
    }
    this.scrollEnd();
  }
  scrollFixed() {
    this.scrollStart();
    if (this.pastTrigger) {
      this.addModifier();
    } else {
      this.removeModifier();
    }
    this.scrollEnd();
  }
  scrollCollapsing() {
    this.scrollStart();
    if (!this.isScrollingDown) {
      this.uncollapse();
    } else {
      this.collapse();
    }
    if (this.pastTrigger) {
      this.addModifier();
    } else {
      this.removeModifier();
    }
    this.scrollEnd();
  }
  bind() {
    this.$on("scroll load ajaxload", window, this.scrollListener);
    this.$on("resize", window, this.calcOffsets);
  }
};
__decorateClass$5([
  ovee_js.dataParam()
], exports.CollapsingHeader.prototype, "collapsingHeader", 2);
__decorateClass$5([
  ovee_js.dataParam()
], exports.CollapsingHeader.prototype, "triggerOffset", 2);
__decorateClass$5([
  ovee_js.dataParam()
], exports.CollapsingHeader.prototype, "offsetMultiplier", 2);
__decorateClass$5([
  ovee_js.dataParam("throttleValue")
], exports.CollapsingHeader.prototype, "_throttleValue", 2);
exports.CollapsingHeader = __decorateClass$5([
  ovee_js.register("collapsing-header")
], exports.CollapsingHeader);

function isIe() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");
  return msie > 0 || /Trident.*rv:11\./.test(navigator.userAgent);
}
function isEdge() {
  return /Edge\/\d./i.test(navigator.userAgent);
}
function isSafari() {
  return /Version\/[\d.]+.*Safari/.test(navigator.userAgent);
}
function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}
function isOpera() {
  const windowWithOpera = window;
  return !!windowWithOpera.opr && !!windowWithOpera.opr.addons || !!windowWithOpera.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
}
function isChrome() {
  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isIEedge = winNav.userAgent.indexOf("Edge") > -1;
  return isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera() === false && isIEedge === false;
}
function isIOS() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}
function isIOSChrome() {
  return /CriOS/.test(navigator.userAgent);
}
function isIOSFirefox() {
  return /FxiOS/.test(navigator.userAgent);
}
function isAndroid() {
  return navigator.userAgent.toLowerCase().indexOf("android") > -1;
}

const rootsMap = /* @__PURE__ */ new Map();
function observeIntersections(element, callback, options = {}) {
  const { root = null, rootMargin = "0px 0px 0px 0px", threshold = 0 } = options;
  if (!rootsMap.has(root)) {
    rootsMap.set(root, /* @__PURE__ */ new Map());
  }
  const map = rootsMap.get(root);
  const key = getObserverKey(rootMargin, threshold);
  if (!map.has(key)) {
    map.set(key, new ObserverEntry(key, { root, rootMargin, threshold }));
  }
  const entry = map.get(key);
  entry.observe(element, callback);
  return () => entry.unobserve(element);
}
function getObserverKey(rootMargin, threshold) {
  const thresholdKey = Array.isArray(threshold) ? threshold.join(",") : `${threshold}`;
  return `${rootMargin}|${thresholdKey}`;
}
class ObserverEntry {
  constructor(key, options) {
    this.key = key;
    this.options = options;
    this.callbacks = /* @__PURE__ */ new Map();
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (this.callbacks.has(entry.target)) {
          const cb = this.callbacks.get(entry.target);
          cb(entry);
        }
      }
    }, options);
  }
  observe(element, callback) {
    if (this.callbacks.has(element))
      return;
    this.observer.observe(element);
    this.callbacks.set(element, callback);
  }
  unobserve(element) {
    this.observer.unobserve(element);
    this.callbacks.delete(element);
    this.tryToDestroy();
  }
  tryToDestroy() {
    if (this.callbacks.size > 0)
      return;
    this.observer.disconnect();
    rootsMap.get(this.options.root)?.delete(this.key);
  }
}

let instance;
class OveeStore {
  constructor() {
    this.stores = {};
  }
  registerStore(name, store) {
    if (this.stores[name]) {
      console.error(`[OveeStore] Store with name '${name}' was already registered!`);
    } else {
      this.stores[name] = store;
    }
  }
  unregisterStore(name) {
    if (this.stores[name]) {
      delete this.stores[name];
    }
  }
  static getInstance() {
    if (!instance) {
      instance = new OveeStore();
    }
    return instance;
  }
}

function createStore(name, stateDef) {
  const state = ovee_js.makeReactive(lodash.isFunction(stateDef) ? stateDef() : lodash.cloneDeep(stateDef));
  const readonlyState = ovee_js.readonly(state);
  OveeStore.getInstance().registerStore(name, state);
  return {
    state: readonlyState,
    getter: createGetter(readonlyState),
    mutation: createMutation(state)
  };
}
function createGetter(state) {
  return (getter) => {
    return ovee_js.makeComputed(() => getter(state));
  };
}
function createMutation(state) {
  return (mutation) => {
    return (payload) => {
      const payloadCopy = lodash.cloneDeep(payload);
      return mutation(state, payloadCopy);
    };
  };
}

const CUSTOM_CURSOR_DEFAULT_OPTIONS = {
  hideDefault: false,
  cursorLerp: true,
  cursorDuration: 0.4,
  shadow: true,
  shadowDuration: 1,
  ripple: false,
  rippleThreshold: 50
};
class Point {
  constructor() {
    this.x = 0;
    this.y = 0;
  }
}
class CustomCursor extends ovee_js.Module {
  constructor() {
    super(...arguments);
    this.mouse = new Point();
    this.shadowPos = new Point();
    this.cursorPos = new Point();
    this.dragPos = new Point();
    this.mode = "";
    this.theme = "";
    this.injected = false;
    this.isSupported = !isIOS() && !isIOSChrome() && !isIOSFirefox() && !isAndroid();
    this.isBinded = false;
    this.isPressed = false;
    this.isMobile = false;
    this.turnOffMobile = lodash.debounce(() => {
      this.isMobile = false;
    }, 50);
    this.text = ovee_js.ref("");
    this.isEnabled = ovee_js.ref(false);
    this.isMoving = null;
  }
  get hideDuration() {
    return this.options.shadow && this.options.shadowDuration > this.options.cursorDuration ? this.options.shadowDuration * 1e3 : this.options.cursorDuration * 1e3;
  }
  init() {
    this.options = {
      ...CUSTOM_CURSOR_DEFAULT_OPTIONS,
      ...this.options
    };
    this.initTemplates();
    this.initSetters();
    this.isEnabled.value = !!this.isSupported;
    this.elementEnterMove = this.elementEnterMove.bind(this);
    this.elementLeave = this.elementLeave.bind(this);
    this.elementModifierChanged = this.elementModifierChanged.bind(this);
    this.lerpHandler = this.lerpHandler.bind(this);
    ovee_js.doWatch(this.isEnabled, this.onEnabledChange.bind(this), { immediate: true });
    ovee_js.doWatch(this.text, this.onTextChange.bind(this), { immediate: true });
  }
  initTemplates() {
    this.cursor = document.createElement("div");
    this.cursor.classList.add("cursor");
    this.cursor.innerHTML = `
			<div class="cursor__content">
				<div class="cursor__background"></div>
				<p class="cursor__text"></p>
			</div>
		`;
    this.shadow = document.createElement("div");
    this.shadow.classList.add("cursor");
    this.shadow.classList.add("cursor--shadow");
    this.shadow.innerHTML = `
			<div class="cursor__content">
				<div class="cursor__background"></div>
			</div>
		`;
    this.ripple = document.createElement("div");
    this.ripple.classList.add("cursor");
    this.ripple.classList.add("cursor--ripple");
    this.ripple.innerHTML = `
			<div class="cursor__content">
				<div class="cursor__background"></div>
			</div>
		`;
  }
  initSetters() {
    this.setY = gsap.gsap.quickSetter(this.cursor, "y", "px");
    this.setX = gsap.gsap.quickSetter(this.cursor, "x", "px");
    this.setShadowY = gsap.gsap.quickSetter(this.shadow, "y", "px");
    this.setShadowX = gsap.gsap.quickSetter(this.shadow, "x", "px");
    this.setRippleY = gsap.gsap.quickSetter(this.ripple, "y", "px");
    this.setRippleX = gsap.gsap.quickSetter(this.ripple, "x", "px");
  }
  onEnabledChange() {
    const root = document.documentElement;
    if (!this.injected) {
      if (this.isEnabled.value) {
        if (this.options.hideDefault)
          root.classList.add("no-cursor");
        this.injectCursor();
        this.bind();
      } else {
        if (this.options.hideDefault)
          root.classList.remove("no-cursor");
        this.hide();
      }
    }
  }
  onTextChange() {
    const textEl = this.cursor.querySelector(".cursor__text");
    if (textEl) {
      if (!this.text.value && textEl.textContent) {
        setTimeout(() => {
          textEl.textContent = this.text.value;
        }, 400);
      } else {
        textEl.textContent = this.text.value;
      }
    }
  }
  injectCursor() {
    if (this.injected)
      return;
    this.injected = true;
    document.body.appendChild(this.cursor);
    if (this.options.shadow) {
      document.body.appendChild(this.shadow);
    }
    this.disable();
  }
  bind() {
    if (this.isBinded)
      return;
    const { documentElement: root, body } = document;
    this.isBinded = true;
    this.$app.$on("mousemove", root, ({ clientX, clientY, target }) => {
      if (this.isMobile)
        return;
      this.updateCursorPosition(clientX, clientY);
      this.moveHander();
      this.detectIsOverLink(target);
    });
    this.$app.$on("touchstart touchend touchmove", root, () => {
      this.hide();
      this.up();
      this.isMobile = true;
      this.turnOffMobile();
    });
    this.$app.$on("mouseout", body, ({ relatedTarget }) => {
      if (relatedTarget === null || relatedTarget === document.documentElement) {
        this.hide();
        this.resetSide();
        this.up();
      }
    });
    this.$app.$on("mousedown", root, () => {
      if (this.isMobile)
        return;
      this.down();
    });
    this.$app.$on("mouseup", root, () => {
      if (this.isMobile)
        return;
      if (this.options.ripple)
        this.createRipple();
      this.up();
    });
    const onScrollDebounce = lodash.debounce(() => {
      this.resetMode();
      this.detectIsOverLink();
    }, 100, { leading: true, trailing: false });
    window.addEventListener("scroll", onScrollDebounce, { passive: true });
  }
  updateCursorPosition(x, y) {
    this.mouse.x = x;
    this.mouse.y = y;
    if (!this.options.cursorLerp) {
      this.setX(this.mouse.x);
      this.setY(this.mouse.y);
    }
    this.onMoveStop();
    this.setSide(x);
  }
  updateDragPosition() {
    this.dragPos.x = this.mouse.x;
    this.dragPos.y = this.mouse.y;
  }
  onMoveStop() {
    if (this.isMoving)
      clearTimeout(this.isMoving);
    this.isMoving = window.setTimeout(() => {
      this.disableTicker();
      this.isMoving = null;
    }, this.hideDuration);
  }
  detectIsOverLink(target) {
    if (target?.tagName === "A" || target?.tagName === "BUTTON" || !!target?.closest("a,button")) {
      this.cursor.classList.add("is-over-link");
      if (this.options.shadow)
        this.shadow.classList.add("is-over-link");
    } else if (target?.dataset.cursorMode === "drag") {
      this.cursor.classList.remove("is-over-link");
      if (this.options.shadow)
        this.shadow.classList.remove("is-over-link");
    } else {
      this.cursor.classList.remove("is-over-link");
      if (this.options.shadow)
        this.shadow.classList.remove("is-over-link");
    }
  }
  lerpHandler() {
    if (this.options.shadow) {
      const dt = 1 - Math.pow(1 - 1 / (this.options.shadowDuration * 10), gsap.gsap.ticker.deltaRatio());
      this.shadowPos.x += (this.mouse.x - this.shadowPos.x) * dt;
      this.shadowPos.y += (this.mouse.y - this.shadowPos.y) * dt;
      this.setShadowX(this.shadowPos.x);
      this.setShadowY(this.shadowPos.y);
    }
    if (this.options.cursorLerp) {
      const dt = 1 - Math.pow(1 - 1 / (this.options.cursorDuration * 10), gsap.gsap.ticker.deltaRatio());
      this.cursorPos.x += (this.mouse.x - this.cursorPos.x) * dt;
      this.cursorPos.y += (this.mouse.y - this.cursorPos.y) * dt;
      this.setX(this.cursorPos.x);
      this.setY(this.cursorPos.y);
    }
  }
  down() {
    if (!this.isPressed) {
      this.cursor.classList.add("is-pressed");
      if (this.options.shadow)
        this.shadow.classList.add("is-pressed");
      this.isPressed = true;
      if (this.options.ripple)
        this.updateDragPosition();
    }
  }
  up() {
    if (this.isPressed) {
      this.cursor.classList.remove("is-pressed");
      if (this.options.shadow)
        this.shadow.classList.remove("is-pressed");
      this.isPressed = false;
      if (this.options.ripple)
        this.updateDragPosition();
    }
  }
  disable() {
    this.isEnabled.value = false;
  }
  enable() {
    this.isEnabled.value = this.isSupported;
  }
  enableTicker() {
    if (this.options.shadow || this.options.cursorLerp) {
      gsap.gsap.ticker.add(this.lerpHandler);
    }
  }
  disableTicker() {
    if (this.options.shadow || this.options.cursorLerp) {
      gsap.gsap.ticker.remove(this.lerpHandler);
    }
  }
  createRipple() {
    const diffX = Math.abs(this.mouse.x - this.dragPos.x);
    const diffY = Math.abs(this.mouse.y - this.dragPos.y);
    if (diffX <= this.options.rippleThreshold && diffY <= this.options.rippleThreshold) {
      this.setRippleX(this.mouse.x);
      this.setRippleY(this.mouse.y);
      const ripple = this.ripple.cloneNode(true);
      ripple.addEventListener("animationend", () => {
        document.body.removeChild(ripple);
      }, { once: true });
      document.body.appendChild(ripple);
    }
  }
  unifyPos() {
    this.cursorPos.x = this.mouse.x;
    this.cursorPos.y = this.mouse.y;
    this.shadowPos.x = this.mouse.x;
    this.shadowPos.y = this.mouse.y;
    this.setX(this.mouse.x);
    this.setY(this.mouse.y);
    this.setShadowX(this.mouse.x);
    this.setShadowY(this.mouse.y);
  }
  moveHander() {
    if (!this.isEnabled.value) {
      this.unifyPos();
    }
    setTimeout(() => {
      this.show();
    });
  }
  show() {
    this.enable();
    this.enableTicker();
    if (this.isEnabled.value) {
      this.cursor.classList.add("is-visible");
      if (this.options.shadow) {
        this.shadow.classList.add("is-visible");
      }
    }
  }
  hide() {
    this.disable();
    if (this.injected) {
      this.cursor.classList.remove("is-visible");
      if (this.options.shadow) {
        this.shadow.classList.remove("is-visible");
      }
    }
  }
  setSide(x) {
    if (this.isEnabled.value) {
      const side = x > window.innerWidth / 2 ? "right" : "left";
      const oppositeSide = side === "left" ? "right" : "left";
      this.cursor.classList.add(`is-${side}`);
      this.cursor.classList.remove(`is-${oppositeSide}`);
      if (this.options.shadow) {
        this.shadow.classList.add(`is-${side}`);
        this.shadow.classList.remove(`is-${oppositeSide}`);
      }
    }
  }
  resetSide() {
    if (this.injected) {
      this.cursor.classList.remove("is-right");
      this.cursor.classList.remove("is-left");
      if (this.options.shadow) {
        this.shadow.classList.remove("is-right");
        this.shadow.classList.remove("is-left");
      }
    }
  }
  setMode(mode) {
    if (this.mode !== mode) {
      this.cursor.dataset.mode = mode;
      if (this.options.shadow)
        this.shadow.dataset.mode = mode;
    }
  }
  resetMode() {
    this.cursor.dataset.mode = "";
    if (this.options.shadow)
      this.shadow.dataset.mode = "";
  }
  setTheme(theme) {
    if (this.theme !== theme) {
      this.cursor.dataset.theme = theme;
      if (this.options.shadow)
        this.shadow.dataset.theme = theme;
    }
  }
  resetTheme() {
    this.cursor.dataset.theme = "";
    if (this.options.shadow)
      this.shadow.dataset.theme = "";
  }
  setText(text) {
    this.text.value = text;
  }
  addModifier(element) {
    element.addEventListener("mouseenter", this.elementEnterMove);
    element.addEventListener("mousemove", this.elementEnterMove);
    element.addEventListener("mouseleave", this.elementLeave);
    element.addEventListener("cursor-modifier-changed", this.elementModifierChanged);
  }
  removeModifier(element) {
    if (this.currentModifier === element) {
      this.resetMode();
      this.resetTheme();
      this.currentModifier = null;
    }
    element.removeEventListener("mouseenter", this.elementEnterMove);
    element.removeEventListener("mousemove", this.elementEnterMove);
    element.removeEventListener("mouseleave", this.elementLeave);
    element.removeEventListener("cursor-modifier-changed", this.elementModifierChanged);
  }
  elementEnterMove({ currentTarget }) {
    const target = currentTarget;
    this.updateCursorModifiers(target);
    this.currentModifier = target;
    this.detectIsOverLink(target);
  }
  elementModifierChanged({ currentTarget }) {
    const target = currentTarget;
    if (target === this.currentModifier) {
      this.updateCursorModifiers(target);
    }
  }
  elementLeave({ currentTarget }) {
    const target = currentTarget;
    this.updateCursorModifiers(target, true);
    if (this.currentModifier === currentTarget) {
      this.currentModifier = null;
    }
  }
  updateCursorModifiers(target, reset = false) {
    const { cursorMode, cursorTheme } = target.dataset;
    if (cursorMode) {
      reset ? this.resetMode() : this.setMode(cursorMode);
    }
    if (cursorTheme) {
      reset ? this.resetTheme() : this.setTheme(cursorTheme);
    }
    if ("cursorText" in target.dataset) {
      this.setText(reset ? "" : target.dataset.cursorText ?? "");
    }
  }
  static getName() {
    return "CustomCursor";
  }
}

var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
class Viewport extends ovee_js.Module {
  constructor() {
    super(...arguments);
    this.vh = 0;
    this.vw = 0;
  }
  init() {
    this.updateUnits();
    this.$app.$on("resize", window, () => this.updateUnits());
    this.$app.$vh = ovee_js.makeComputed(() => this.vh);
    this.$app.$vw = ovee_js.makeComputed(() => this.vw);
  }
  updateUnits() {
    this.vh = document.documentElement.clientHeight / 100;
    this.vw = window.innerWidth / 100;
    window.document.documentElement.style.setProperty("--vh", `${this.vh}px`);
    window.document.documentElement.style.setProperty("--vw", `${this.vw}px`);
  }
  static getName() {
    return "Viewport";
  }
}
__decorateClass$4([
  ovee_js.reactive()
], Viewport.prototype, "vh", 2);
__decorateClass$4([
  ovee_js.reactive()
], Viewport.prototype, "vw", 2);

var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
exports.CursorModifier = class extends ovee_js.Component {
  init() {
    this.CustomCursor = this.$app.getModule(CustomCursor.getName());
    this.CustomCursor.addModifier(this.$element);
  }
  destroy() {
    this.CustomCursor.removeModifier(this.$element);
  }
};
exports.CursorModifier = __decorateClass$3([
  ovee_js.register("cursor-modifier")
], exports.CursorModifier);

var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
const logger$1 = new ovee_js.Logger("NavToggle");
const DEFAULT_NAV_NAME = "menu";
exports.NavToggle = class extends ovee_js.Component {
  constructor() {
    super(...arguments);
    this.html = document.documentElement;
    this.isOpen = false;
  }
  get showImmediately() {
    return this._showImmediately === "true";
  }
  get hideImmediately() {
    return this._hideImmediately === "true";
  }
  init() {
    if (!this.navName) {
      this.navName = DEFAULT_NAV_NAME;
    }
    if (!this.navSelector) {
      logger$1.error(`Attribute 'data-nav' with value is required`);
      return;
    }
    const nav = document.querySelector(this.navSelector);
    if (!nav) {
      logger$1.error(`Could not find nav with selector: '${this.navSelector}'`);
      return;
    }
    this.nav = nav;
    this.bind();
  }
  bind() {
    this.$on("nav-toggle:show", this.onNavShow);
    this.$on("nav-toggle:hide", this.onNavHide);
    this.$on("transitionstart", this.nav, this.animStart);
    this.$on("transitionend", this.nav, this.animEnd);
  }
  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.isOpen) {
      this.hide(this.hideImmediately);
    } else {
      this.show(this.showImmediately);
    }
  }
  onNavShow(e) {
    this.show(e.detail);
  }
  onNavHide(e) {
    this.hide(e.detail);
  }
  animStart() {
    if (this.animStarted) {
      return;
    }
    this.animStarted = true;
    if (this.isOpen) {
      this.html.classList.add(`${this.navName}-anim`);
    } else {
      this.html.classList.add(`${this.navName}-hide-anim`);
    }
  }
  animEnd() {
    if (!this.animStarted) {
      return;
    }
    this.animStarted = false;
    if (this.isOpen) {
      this.html.classList.remove(`${this.navName}-anim`);
    } else {
      this.html.classList.remove(`${this.navName}-hide-anim`);
    }
  }
  show(immediately = false) {
    this.isOpen = true;
    if (immediately) {
      this.html.classList.add(`${this.navName}-show-immediately`);
      requestAnimationFrame(() => {
        this.html.classList.remove(`${this.navName}-show-immediately`);
      });
    }
    this.html.classList.add(`${this.navName}-visible`);
    this.$element.setAttribute("aria-expanded", "true");
    this.$emit("nav-toggle:visible", this.$element);
    ovee_js.emitEvent(window, "nav-toggle:visible", {
      element: this.$element,
      navName: this.navName
    });
  }
  hide(immediately = false) {
    this.isOpen = false;
    if (immediately) {
      this.html.classList.add(`${this.navName}-hide-immediately`);
      requestAnimationFrame(() => {
        this.html.classList.remove(`${this.navName}-hide-immediately`);
      });
    }
    this.html.classList.remove(`${this.navName}-visible`);
    this.$element.setAttribute("aria-expanded", "false");
    this.$emit("nav-toggle:hidden", this.$element);
    ovee_js.emitEvent(window, "nav-toggle:hidden", {
      element: this.$element,
      navName: this.navName
    });
  }
};
__decorateClass$2([
  ovee_js.dataParam("navToggle")
], exports.NavToggle.prototype, "navName", 2);
__decorateClass$2([
  ovee_js.dataParam("nav")
], exports.NavToggle.prototype, "navSelector", 2);
__decorateClass$2([
  ovee_js.dataParam("showImmediately")
], exports.NavToggle.prototype, "_showImmediately", 2);
__decorateClass$2([
  ovee_js.dataParam("hideImmediately")
], exports.NavToggle.prototype, "_hideImmediately", 2);
__decorateClass$2([
  ovee_js.bind("click")
], exports.NavToggle.prototype, "onClick", 1);
exports.NavToggle = __decorateClass$2([
  ovee_js.register("nav-toggle")
], exports.NavToggle);

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
gsap.gsap.registerPlugin(ScrollTrigger.ScrollTrigger);
const logger = new ovee_js.Logger("ParallaxEffect");
const PARALLAX_EFFECT_DEFAULT_OPTIONS = {
  scrub: true,
  target: "",
  disableOnMobile: true,
  disableOnTablet: true,
  tweenVars: {
    y: 100
  }
};
exports.ParallaxEffect = class extends ovee_js.Component {
  constructor() {
    super(...arguments);
    this._parallaxOptions = "";
  }
  get baseOptions() {
    return {
      ...PARALLAX_EFFECT_DEFAULT_OPTIONS,
      target: this.$element,
      ...this.$options
    };
  }
  get parallaxConfig() {
    const { baseOptions } = this;
    if (!this._parallaxOptions) {
      return baseOptions;
    }
    let elementOptions;
    try {
      elementOptions = JSON.parse(this._parallaxOptions);
    } catch (e) {
      logger.error("Invalid JSON Config:", this._parallaxOptions);
      return baseOptions;
    }
    return {
      ...baseOptions,
      ...elementOptions
    };
  }
  get desktopBreakpoint() {
    return "(min-width: 1200px)";
  }
  get tabletBreakpoint() {
    return "(max-width: 1199px)";
  }
  get mobileBreakpoint() {
    return "(max-width: 767px), (max-width: 1023px) and (orientation: landscape)";
  }
  init() {
    this.createParallax();
  }
  createParallax() {
    const { parallaxConfig, desktopBreakpoint, tabletBreakpoint, mobileBreakpoint } = this;
    const { disableOnMobile, disableOnTablet, tweenVars, target, trigger } = parallaxConfig;
    let breakpoint = desktopBreakpoint;
    if (!disableOnTablet) {
      breakpoint += `, ${tabletBreakpoint}`;
    }
    if (!disableOnMobile) {
      breakpoint += `, ${mobileBreakpoint}`;
    }
    if (!Object.keys(tweenVars).length) {
      logger.error(`Property "tweenVars" is empty`);
      return;
    }
    const to = {};
    for (const prop in tweenVars) {
      if (!Object.prototype.hasOwnProperty.call(tweenVars, prop)) {
        return;
      }
      const value = tweenVars[prop];
      to[prop] = value;
    }
    ScrollTrigger.ScrollTrigger.matchMedia({
      [breakpoint]: () => {
        this.tl = gsap.gsap.timeline({
          paused: true
        });
        this.tl.to(target, to);
        if (!trigger) {
          parallaxConfig.trigger = target;
        }
        this.st = ScrollTrigger.ScrollTrigger.create({
          ...parallaxConfig,
          animation: this.tl
        });
        return () => {
          this.tl.kill();
        };
      }
    });
  }
  destroy() {
    this.tl?.kill();
    this.st?.kill();
  }
};
__decorateClass$1([
  ovee_js.dataParam("parallaxOptions")
], exports.ParallaxEffect.prototype, "_parallaxOptions", 2);
exports.ParallaxEffect = __decorateClass$1([
  ovee_js.register("parallax-effect")
], exports.ParallaxEffect);

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const IN_VIEWPORT_DEFAULT_OPTIONS = {
  threshold: 0.5
};
exports.InViewport = class extends ovee_js.Component {
  constructor() {
    super(...arguments);
    this._threshold = `${this.options.threshold}`;
    this.selector = "";
  }
  get options() {
    return {
      ...IN_VIEWPORT_DEFAULT_OPTIONS,
      ...this.$options
    };
  }
  get threshold() {
    const parsed = JSON.parse(this._threshold);
    return Array.isArray(parsed) || lodash.isNumber(parsed) ? parsed : this.options.threshold;
  }
  init() {
    const $el = this.$element;
    const context = $el.dataset.selector ? $el.querySelector($el.dataset.selector) ?? $el : $el;
    this.unonbserve = observeIntersections(context, (entry) => {
      if (entry.isIntersecting) {
        this.showTarget(entry.target);
      }
    }, { threshold: this.threshold });
  }
  destroy() {
    this.unonbserve?.();
  }
  showTarget(target) {
    target.classList.add("is-in-viewport");
  }
};
__decorateClass([
  ovee_js.dataParam("threshold")
], exports.InViewport.prototype, "_threshold", 2);
__decorateClass([
  ovee_js.dataParam()
], exports.InViewport.prototype, "selector", 2);
exports.InViewport = __decorateClass([
  ovee_js.register("in-viewport")
], exports.InViewport);

const DEFAULT_THRESHOLD = [0, 1];
function WithInViewport(Ctor) {
  class _WithInViewport extends Ctor {
    get observerOptions() {
      return {
        threshold: WithInViewport.config.threshold
      };
    }
    init() {
      super.init();
      this.unobserve = observeIntersections(this.$element, (entry) => {
        this.onIntersection(entry);
      }, this.observerOptions);
    }
    destroy() {
      this.unobserve?.();
      super.destroy();
    }
    onIntersection(entry) {
    }
  }
  return _WithInViewport;
}
WithInViewport.config = {
  threshold: DEFAULT_THRESHOLD
};

function updateConfig(base, config) {
  if (lodash.isUndefined(config))
    return;
  base.config = lodash.defaultsDeep({}, config, base.config);
}

exports.BASE_ACCORDION_DEFAULT_OPTIONS = BASE_ACCORDION_DEFAULT_OPTIONS;
exports.BASE_COOKIES_DEFAULT_OPTIONS = BASE_COOKIES_DEFAULT_OPTIONS;
exports.BASE_DIALOG_DEFAULT_OPTIONS = BASE_DIALOG_DEFAULT_OPTIONS;
exports.BaseDialog = BaseDialog;
exports.COLLAPSING_HEADER_DEFAULT_OPTIONS = COLLAPSING_HEADER_DEFAULT_OPTIONS;
exports.CUSTOM_CURSOR_DEFAULT_OPTIONS = CUSTOM_CURSOR_DEFAULT_OPTIONS;
exports.CustomCursor = CustomCursor;
exports.IN_VIEWPORT_DEFAULT_OPTIONS = IN_VIEWPORT_DEFAULT_OPTIONS;
exports.ObserverEntry = ObserverEntry;
exports.OveeStore = OveeStore;
exports.PARALLAX_EFFECT_DEFAULT_OPTIONS = PARALLAX_EFFECT_DEFAULT_OPTIONS;
exports.Point = Point;
exports.Viewport = Viewport;
exports.WithInViewport = WithInViewport;
exports.createStore = createStore;
exports.isAndroid = isAndroid;
exports.isChrome = isChrome;
exports.isEdge = isEdge;
exports.isFirefox = isFirefox;
exports.isIOS = isIOS;
exports.isIOSChrome = isIOSChrome;
exports.isIOSFirefox = isIOSFirefox;
exports.isIe = isIe;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.observeIntersections = observeIntersections;
exports.updateConfig = updateConfig;
